import React from "react";

const DayRateIcon = ({ cls }) => {
  return (
    <svg
      height="512"
      viewBox="0 0 24 24"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <g id="open_24_hours">
        <g>
          <path
            d="m12 6c-.5527344 0-1 .4472656-1 1v5c0 .265625.1054688.5195313.2929688.7070313l3 3c.1953125.1953125.4511718.2929687.7070312.2929687s.5117188-.0976563.7070313-.2929688c.390625-.390625.390625-1.0234375 0-1.4140625l-2.7070313-2.7070312v-4.5859375c0-.5527344-.4472656-1-1-1z"
            fill="currentColor"
          />
          <path
            d="m21 11c-.5527344 0-1 .4472656-1 1 0 4.4111328-3.5888672 8-8 8s-8-3.5888672-8-8 3.5888672-8 8-8c2.4599609 0 4.7167969 1.1279297 6.2167969 3h-2.2167969c-.5527344 0-1 .4472656-1 1s.4472656 1 1 1h4c.5527344 0 1-.4472656 1-1v-4c0-.5527344-.4472656-1-1-1s-1 .4472656-1 1v.8867188c-1.8378906-1.8164063-4.3232422-2.8867188-7-2.8867188-5.5136719 0-10 4.4863281-10 10s4.4863281 10 10 10 10-4.4863281 10-10c0-.5527344-.4472656-1-1-1z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  );
};

export default DayRateIcon;
